import { useEffect, useRef, useState } from 'react';
import noop from 'lodash/noop';
const loadImage = (onLoad, onError) => (src, isAnonymous) => {
    const image = new Image();
    if (isAnonymous) {
        image.crossOrigin = 'anonymous';
    }
    // attach listeners
    image.onload = onLoad;
    image.onerror = onError;
    // preload the actual image
    image.src = src;
    return image;
};
const ImagePreloader = (props) => {
    const { src, isAnonymous = false, onLoaded = noop, onFailed = noop, children } = props;
    const [status, setStatus] = useState('PENDING');
    const [image, setImage] = useState();
    const willUnmount = useRef(false);
    const handleImageLoaded = () => {
        if (willUnmount.current) {
            return;
        }
        setStatus('LOADED');
        onLoaded(image);
    };
    const handleImageFailed = () => {
        if (willUnmount.current) {
            return;
        }
        setStatus('FAILED');
        onFailed(image);
    };
    const loadImageWithCallbacks = loadImage(handleImageLoaded, handleImageFailed);
    useEffect(() => {
        setImage(loadImageWithCallbacks(src, isAnonymous));
        return () => {
            willUnmount.current = true;
        };
    }, []);
    useEffect(() => {
        setStatus('PENDING');
        setImage(loadImageWithCallbacks(src, isAnonymous));
    }, [src]);
    return children ? children({ status, image: image }) : null;
};
ImagePreloader.STATUS_PENDING = 'PENDING';
ImagePreloader.STATUS_LOADED = 'LOADED';
ImagePreloader.STATUS_FAILED = 'FAILED';
export default ImagePreloader;
